module.exports = __webpack_public_path__ + "bb1.no2.738555d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bb1.no2.jpg
// module id = r9ue
// module chunks = 0